<template>
  <div class="publicMain">
    <el-row style="margin-bottom: 10px;">
      <el-col :span="4">
        <el-select v-model="bfl" size="small" style="width: 60%;" @change="bflChange">
          <el-option v-for="item in optionsBfl" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick" :key="activeName">
        <el-tab-pane :label="item.label" :name="item.value" v-for="item in optionsTab" :key="item.value">
          <el-row>
            <el-col :span="7">
              <el-card>
                <el-tree
                  :style="treeStyle"
                  :data="bflTreeData"
                  node-key="id"
                  default-expand-all
                  :props="treeDefaultProps" 
                  :expand-on-click-node="false"
                  @node-click="handleNodeClick" >
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ node.label }}</span>
                    <span>
                      <el-button type="text" size="mini" @click="() => openDialog(node, data, 'add')">添加</el-button>
                      <el-button type="text" size="mini" :disabled="data.id=='0'" @click="() => openDialog(node, data, 'edit')">编辑</el-button>
                      <el-button type="text" size="mini" :disabled="data.id=='0'" @click="() => openDialog(node, data, 'del')">删除</el-button>
                    </span>
                  </span>
                </el-tree>
              </el-card>
            </el-col>
            <el-col :span="17" style="padding-left: 10px;">
              <el-card>
                <div slot="header">
                  <el-row>
                    <el-col :span="12" style="display: flex; align-items: center;">
                      <el-divider direction="vertical"></el-divider>
                      <span>归类设置</span>
                    </el-col>
                    <el-col v-if="sfqynd" :span="12" style="text-align: right;">
                      <label class="labelClass" style="padding-right: 10px; padding-left: 50px;">{{ '会计年度' }}</label>
                      <el-select v-model="kjnd" class="selectClass" default-first-option :placeholder="'会计年度'"
                        @change="changeKjnd" size="mini" style="width: 120px;">
                        <el-option
                          v-for="item in optionsKjnd"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col v-if="staffList.sfqy == '1'&&copyBtnFlg" :span="12" style="text-align: right;">
                      <el-button type="primary" class="copyBtnClass" size="mini" @click="openDialog('', '', 'copy')">{{ '复制' }}</el-button>
                    </el-col>
                  </el-row>
                </div>
                <div>
                  <el-row style="display: flex; align-items: center;">
                    <el-col :span="11">
                      <el-row style="display: flex; align-items: center; margin-bottom: 5px;">
                        <el-col :span="12">
                          <span>{{ '未归类：' }}</span>
                        </el-col>
                        <el-col :span="12">
                          <el-input v-model="gllVal1" suffix-icon="el-icon-search" placeholder="请输入搜索内容"
                            size="mini" @input="inputChange('1')" clearable></el-input>
                        </el-col>
                      </el-row>
                      <el-table
                        ref="leftTable"
                        :height="tableHeight"
                        v-loading="wglListLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
                        :row-key="getRowKeys"
                        :data="transferData"
                        border
                        fit
                        highlight-current-row
                        @selection-change="handleStaffChange($event, 'left')"
                        v-if="stataFlg == true"
                      >
                      <el-table-column type="selection" :reserve-selection="true" align="center" width="55"></el-table-column>
                      <el-table-column align="left" header-align="center" :label="staffList.gldm" prop="gll"></el-table-column>
                      </el-table>
                      <Pagination v-if="paginationFlg" :currentPage="leftCurrentPage" :total="leftTotal" :limit="leftLimit" :small="true" :pageSizes="$store.state.pageSizes"
                        @handleCurrentChange="leftHandleCurrentChange" @handleSizeChange="leftHandleSizeChange" :layout="layout" />
                    </el-col>
                    <el-col :span="2" class="col2Class">
                      <el-row style="display: flex; justify-content: center;">
                        <el-button type="primary" icon="el-icon-arrow-right" circle style="margin-bottom: 10px;"
                          @click="updateGlsz" :disabled="leftStaffData.length == 0 ? topBtnFlg=true : topBtnFlg=false"></el-button>
                      </el-row>
                      <el-row style="display: flex; justify-content: center;">
                        <el-button type="primary" icon="el-icon-arrow-left" circle
                          @click="revokeGlsz" :disabled="rightStaffData.length == 0 ? bottomBtnFlg=true : bottomBtnFlg=false"></el-button>
                      </el-row>
                    </el-col>
                    <el-col :span="11">
                      <el-row style="display: flex; align-items: center; margin-bottom: 5px;">
                        <el-col :span="12">
                          <span>{{ '已归类：' }}</span>
                        </el-col>
                        <el-col :span="12">
                          <el-input v-model="gllVal2" suffix-icon="el-icon-search" placeholder="请输入搜索内容"
                            size="mini" @input="inputChange('2')" clearable></el-input>
                        </el-col>
                      </el-row>
                      <el-table
                        ref="staffTable"
                        :height="tableHeight"
                        v-loading="wglListLoading"
        :element-loading-text="$t('elTable.loadingText')"
                        :row-key="getRowKeys"
                        :data="transferVal"
                        border
                        fit
                        highlight-current-row
                        @selection-change="handleStaffChange($event, 'right')"
                        v-if="stataFlg == true"
                      >
                      <el-table-column type="selection" :reserve-selection="true" align="center" width="55"></el-table-column>
                      <el-table-column align="left" header-align="center" :label="staffList.gldm" prop="gll"></el-table-column>
                      </el-table>
                      <Pagination v-if="paginationFlg" :currentPage="rightCurrentPage" :total="rightTotal" :limit="rightLimit" :small="true" :pageSizes="$store.state.pageSizes"
                        @handleCurrentChange="rightHandleCurrentChange" @handleSizeChange="rightHandleSizeChange" :layout="layout" />
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <!-- 树节点模态框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      :close-on-press-escape="true" @close="handleClose">
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
          </span>
        </i>
      </label>
      <el-card style="padding: 0 20% 0 20%">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px"
          :validate-on-rule-change="false" size="small">
          <el-form-item :label="'节点名称'" prop="jdmc">
            <el-input v-model="ruleForm.jdmc"></el-input>
          </el-form-item>
          <el-form-item :label="'适配页面'" prop="pageId" v-if="ruleForm.flg">
            <el-select v-model="ruleForm.pageId" default-first-option clearable
              :placeholder="'请选择页面'" style="width: 100%" multiple collapse-tags>
              <el-option
                v-for="item in optionsPages"
                :key="item.value"
                :label="item.label[$i18n.locale]"
                :value="item.value">
                <span style="float: left">{{ item.value }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.label[$i18n.locale] }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">{{ '取消' }}</el-button>
        <el-button type="primary" size="small" @click="submitForm('ruleForm')">{{ '保存' }}</el-button>
      </div>
    </el-dialog>
    <!-- 复制已归类设置 -->
    <el-dialog :title="dialogTitle" :visible.sync="copyDiaFormVisible" :close-on-click-modal="false"
      :close-on-press-escape="true" @close="copyHandleClose">
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
          </span>
        </i>
      </label>
      <el-card>
        <el-row style="display: flex; align-items: center;">
          <el-col :span="12" style="margin-right: 5px;">
            <el-row style="display: flex; align-items: center; margin-bottom: 5px;">
              <el-col :span="12">
                <span>{{ '源：' }}</span>
              </el-col>
            </el-row>
            <el-select v-model="srcKjnd" default-first-option clearable size="small"
              :placeholder="'请选择源会计年度'" style="width: 70%" collapse-tags>
              <el-option
                v-for="item in optionsYglKjnd"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <!-- <el-table
              ref="yglKjndLeftTable"
              :height="tableHeight"
              v-loading="yglKjndListLoading"
              :row-key="getRowKeys"
              :data="optionsYglKjnd"
              border
              fit
              highlight-current-row
              @select="leftSelect"
              class="leftKjndClass"
            >
              <el-table-column type="selection" :reserve-selection="true" align="center" width="55"></el-table-column>
              <el-table-column align="center" :label="'节点名称'" prop="jdmc"></el-table-column>
              <el-table-column align="center" :label="'会计年度'" prop="kjnd"></el-table-column>
            </el-table> -->
          </el-col>
          <el-col :span="12" style="margin-left: 5px;">
            <el-row style="display: flex; align-items: center; margin-bottom: 5px;">
              <el-col :span="12">
                <span>{{ '目标：' }}</span>
              </el-col>
            </el-row>
            <el-select v-model="targetKjnd" default-first-option clearable size="small"
              :placeholder="'请选择目标会计年度'" style="width: 70%" multiple collapse-tags>
              <el-option
                v-for="item in optionsWglKjnd"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <!-- <el-table
              ref="wglKjndLeftTable"
              :height="tableHeight"
              v-loading="yglKjndListLoading"
              :row-key="getRowKeys"
              :data="optionsWglKjnd"
              border
              fit
              highlight-current-row
              @select="rightSelect"
            >
              <el-table-column type="selection" :reserve-selection="true" align="center" width="55"></el-table-column>
              <el-table-column align="center" :label="'会计年度'" prop="kjnd"></el-table-column>
            </el-table> -->
          </el-col>
        </el-row>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="copyOkBtnFlg" type="primary" size="small" @click="copyKjnd">{{ '确定复制' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  name: 'glsz',
  data() {
    return {
      kjnd: '',    // 会计年度
      gllVal1: '',
      gllVal2: '',
      activeName: '',
      bfl: '',
      jdbh: '',
      bmc: '',
      optionsBfl: [],    // 表分类
      optionsTab: [],    // 表分类选项
      // optionsTabName: [],    // 表名称选项
      optionsPages: [],    // 页面ID集合
      dialogTitle: '',    // 模态框标题
      dialogTitleIcon: '',    // 模态框标题图标
      bflTreeData: [{
        id: '0',
        jdmc: '全部',
        children: []
      }],
      ruleForm: {    // 树节点数据
        jdmc: '',
        pageId: [],
        flg: false,
      },
      dialogFormVisible: false,
      staffList: {},    // 归类字段
      wglListLoading: false,
      yglListLoading: false,
      wglKjndListLoading: false,
      yglKjndListLoading: false,
      transferData: [],    // 穿梭框数据
      transferVal: [],
      leftStaffData: [],    // 左边表格选择
      rightStaffData: [],    // 右边表格选择
      topBtnFlg: false,
      bottomBtnFlg: false,
      screenHeight: '0',
      screenWidth: '0',
      stataFlg: true,
      leftCurrentPage: 1,    // 页码
      leftLimit: this.$store.state.dataDisplayNum,    // 分页显示条数
      leftTotal: 0,    // 列表数据量
      leftPageSizes: this.$store.state.pageSizes,    // 分页显示可选择条数
      rightCurrentPage: 1,    // 页码
      rightLimit: this.$store.state.dataDisplayNum,    // 分页显示条数
      rightTotal: 0,    // 列表数据量
      rightPageSizes: this.$store.state.pageSizes,    // 分页显示可选择条数
      layout: 'total, sizes, jumper',
      leftQueryForm: {},
      rightQueryForm: {},
      paginationFlg: false,
      sfqynd: false,    // 是否启用年度
      copyBtnFlg: false,
      optionsKjnd: [],    // 会计年度选项
      tmpChangeKjndData: {},    // 切换会计年度临时查询用数据
      copyDiaFormVisible: false,    // 复制已归类模态框状态
      optionsYglKjnd: [],    // 已归类会计年度选项
      optionsWglKjnd: [],    // 未归类会计年度选项
      leftKjndStaffData: [],    // 已选择已归类会计年度选项
      rightKjndStaffData: [],    // 未选择已归类会计年度选项
      treeId: '',    // 当前点击treeId
      srcKjnd: '',
      targetKjnd: [],
    };
  },
  computed: {
    // transferStyle() {
    //   return {
    //     'height': this.screenHeight - 389 + 'px',
    //   }
    // },
    treeStyle() {
      return {
        'height': this.screenHeight - 326 + 'px',
        'overflow-y': 'auto',
      }
    },
    tableHeight() {
      return this.paginationFlg ? (this.screenHeight - 436) : (this.screenHeight - 400)
    },
    treeDefaultProps() {    // 默认节点绑定数据
      return {
        id: 'id',
        pid: 'pid',
        bfl: "bfl",
        bmc: "bmc",
        jdbh: "jdbh",
        label: 'jdmc',
        pageId: "pageId",
        children: "children"
      }
    },
    rules() {    // 模态框数据校验规则
      return {
        jdmc: [{ required: true, message: "请输入节点名称", trigger: "blur" }],
        bmc: [{ required: true, message: "请选择表名称", trigger: "change" }],
        bfl: [{ required: true, message: "请选择表分类", trigger: "change" }],
      }
    },
    copyOkBtnFlg() {
      return this.srcKjnd == '' || this.targetKjnd.length == 0
    }
  },
  watch: {},
  methods:{
    inputChange(flg) {
      let tmpObj = {}
      tmpObj.bmc = this.bmc
      tmpObj.bfl = this.bfl
      tmpObj.jdbh = this.jdbh
      tmpObj.gldm = this.staffList.gldm;
      tmpObj.glmc = this.staffList.glmc;
      tmpObj.kjnd = this.kjnd;
      if(flg == '1') {
        tmpObj.gllVal1 = this.gllVal1;
        this.tmpChangeKjndData = tmpObj;
        this.getWglList(tmpObj, 'query');
      } else if(flg == '2') {
        tmpObj.gllVal2 = this.gllVal2;
        this.tmpChangeKjndData = tmpObj;
        this.getYglList(tmpObj, 'query');
      }
    },
    /** 切换表分类选项 */
    async bflChange() {
      this.transferData = []
      this.transferVal = []
      this.leftStaffData = []
      this.rightStaffData = []
      this.sfqynd = false
      this.copyBtnFlg = false
      await this.getOptionsTab(this.bfl);
      await this.getBflTree(this.bfl, this.activeName);
      await this.getGlzd({ bmc: this.activeName, bfl: this.bfl });
    },
    /** 获取表分类选择项 */
    async getOptionsTab(flg) {
      let _this = this;
      _this.activeName = ''
      _this.optionsTab = [];
      await _this.$ajax.post("/api/xtglGlsz/getOptionsTab", { bfl: flg }).then((res) => {
        if(res.data.code == '200') {
          for (let tmp of res.data.data) {
            _this.optionsTab.push({
              label: tmp.bms,
              value: tmp.bmc,
              sfqy: tmp.sfqy,
            });
          }
          if(_this.optionsTab.length > 0) {
            _this.activeName = _this.optionsTab[0].value
          }
        }
      })
    },
    async getBflTree(bfl, bmc) {
      let _this = this;
      await _this.$ajax.post("/api/xtglGlsz/getBflTree", { bfl: bfl, bmc: bmc }).then((res) => {
        if(res.data.code == '200') {
          _this.bflTreeData[0].children = []
          _this.bflTreeData[0].children = res.data.data
        }
      })
    },
    async openDialog(node, data, flg) {
      if(flg == 'add') {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = '新增节点';
          this.dialogTitleIcon = 'el-icon-document-add';
          this.ruleForm.bmc = this.activeName;
          this.ruleForm.bfl = this.bfl;
          this.ruleForm.pid = data.id
          data.id == 0 ? this.ruleForm.flg = true : this.ruleForm.flg = false
          if(data.children.length == 0) {
            data.id == 0 ? this.ruleForm.jdbh = '0001' : this.ruleForm.jdbh = data.jdbh + '01'
          } else {
            let tmpChild = data.children
            let max = tmpChild[0].jdbh;
            for (let i = 0; i < tmpChild.length - 1; i++) {
              max = max < tmpChild[i + 1].jdbh ? tmpChild[i + 1].jdbh : max
            }
            this.ruleForm.jdbh = (Array(max.length).join('0') + (parseInt(max) + 1)).slice(-max.length);
          }
        })
      } else if(flg == 'edit') {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = '编辑节点';
          this.dialogTitleIcon = 'el-icon-edit-outline';
          this.ruleForm.id = data.id
          this.ruleForm.jdmc = data.jdmc
          this.ruleForm.pageId = data.pageId ? data.pageId.split(',') : ''
          data.pid == 0 ? this.ruleForm.flg = true : this.ruleForm.flg = false
        })
      } else if(flg == 'del') {
        let tmpObj = {
          id: data.id,
          bmc: data.bmc,
          bfl: data.bfl
        }
        this.delTreeNode(tmpObj);
      } else if(flg == 'copy') {
        await this.getYglKjnd(this.treeId);
        await this.getWglKjnd(this.activeName);
        this.copyDiaFormVisible = true
        this.dialogTitle = '复制归类设置';
        this.dialogTitleIcon = 'el-icon-copy-document';
      }
      this.saveFlg = flg;
    },
    /** 保存模态框数据 */
    submitForm(formName) {
      let _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.ruleForm.pageId.length > 0 ? _this.ruleForm.pageId = _this.ruleForm.pageId.join(',') : _this.ruleForm.pageId = ""
          if(_this.saveFlg === 'add') {
            _this.addTreeNode();
          } else if(_this.saveFlg === 'edit') {
            _this.editTreeNode();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /** 添加树节点 */
    addTreeNode() {
      let _this = this;
      _this.$ajax.post('/api/xtglGlsz/addTreeNode', _this.ruleForm).then((res) => {
        _this.dialogFormVisible = false;
        if(res.data.code == '200') {
          _this.getBflTree(this.bfl, this.activeName);
          _this.$message.success('归类设置，添加成功');
        }
      }).catch((error) => {
        _this.dialogFormVisible = false;
      });
    },
    /** 编辑树节点 */
    editTreeNode() {
      let _this = this;
      _this.$ajax.post('/api/xtglGlsz/editTreeNode', _this.ruleForm).then((res) => {
        _this.dialogFormVisible = false;
        if(res.data.code == '200') {
          _this.getBflTree(this.bfl, this.activeName);
          _this.$message.success('归类设置，编辑成功');
        }
      }).catch((error) => {
        _this.dialogFormVisible = false;
      });
    },
    /** 删除树节点 */
    delTreeNode(data) {
      let _this = this;
      _this.$confirm(_this.$t('common.deleteContent'), _this.$t('common.deleteTitle'), {
        distinguishCancelAndClose: true,
        confirmButtonText: _this.$t('common.confirmBtn'),
        cancelButtonText: _this.$t('common.cancelBtn')
      }).then(res1 => {
        _this.$ajax.post("/api/xtglGlsz/delTreeNode", data).then((res) => {
          if(res.data.code == '200') {
            _this.getBflTree(this.bfl, this.activeName);
            _this.$message.success(_this.$t('common.delSuccess'));
            _this.transferData = []
            _this.transferVal = []
            _this.leftStaffData = []
            _this.rightStaffData = []
            // 通过v-if手动销毁，重新渲染
            _this.stataFlg = false;
            _this.$nextTick(() => {
              _this.stataFlg = true;
            });
          }
        })
      }).catch(action => {
        // this.$message.info({
        //   message: action === 'cancel' ? '放弃保存并离开页面' : '停留在当前页面'
        // })
      });
    },
    handleClick(tab, event) {
      this.transferData = []
      this.transferVal = []
      this.leftStaffData = []
      this.rightStaffData = []
      this.staffList = []
      this.sfqynd = false
      this.copyBtnFlg = false
      this.getBflTree(this.bfl, this.activeName);
      this.getGlzd({ bmc: this.activeName, bfl: this.bfl });
    },
    async handleNodeClick(data) {
      const _this = this;
      _this.$nextTick(function () {
        // 先获取节点
        let array = document.querySelectorAll('.is-current');
        if (array && array.length > 0) {
          for (let i = 0; i < array.length; i++) {
            const element = array[i].getElementsByClassName('el-tree-node__content');
            $('.el-tree-node__content').removeClass("s-bg2");
            $('.el-tree-node__content').removeClass("s-c");
            for (let j = 0; j < element.length; j++) {
              if (data.hasOwnProperty('children')) {
                if (element[j].className.indexOf('s-bg2') === -1) {
                  element[0].className += " s-bg2 s-c";
                }
              } else {
                if (element[j].className.indexOf('s-bg2') === -1) {
                  element[j].className += " s-bg2 s-c";
                }
              }
            }
          }
        }
      });
      _this.copyBtnFlg = false
      _this.jdbh = data.jdbh
      _this.treeId = ''
      _this.treeId = data.id
      if(data.children.length > 0 || data.id == 0 || data.pid == 0) {
        _this.transferData = []
        _this.transferVal = []
        _this.staffList = []
        _this.paginationFlg = false
        _this.sfqynd = false
        if(data.pid == 0) {
          _this.copyBtnFlg = true
        }
        await _this.getGlzd({ bmc: _this.activeName, bfl: _this.bfl });
        return
      }
      _this.paginationFlg = true
      _this.bmc = _this.activeName,
      data.gldm = _this.staffList.gldm;
      data.glmc = _this.staffList.glmc;
      _this.sfqynd = _this.staffList.sfqy == '1' ? true : false;
      _this.optionsKjnd = []
      _this.kjnd = ''
      if(_this.staffList.sfqy == '1') {
        await _this.getOptionsKjnd(data);
      }
      data.kjnd = _this.kjnd;
      data.gllVal1 = _this.gllVal1;
      data.gllVal2 = _this.gllVal2;
      _this.wglListLoading = true;
      _this.yglListLoading = true;
      _this.tmpChangeKjndData = data
      await _this.getWglList(data);
      await _this.getYglList(data);
    },
    // 切换会计年度
    async changeKjnd() {
      let _this = this
      _this.transferData = []
      _this.transferVal = []
      _this.wglListLoading = true;
      _this.yglListLoading = true;
      _this.tmpChangeKjndData.kjnd = _this.kjnd
      await _this.getWglList(_this.tmpChangeKjndData, 'query');
      await _this.getYglList(_this.tmpChangeKjndData, 'query');
    },
    /** 获取会计年度选项 */
    async getOptionsKjnd(data) {
      let _this = this
      await _this.$ajax.post("/api/xtglGlsz/getOptionsKjnd", data).then((res) => {
        if(res.data.code == '200') {
          for (let tmp of res.data.data) {
            _this.optionsKjnd.push({
              label: tmp.kjnd,
              value: tmp.kjnd,
            });
          }
          _this.kjnd = _this.optionsKjnd[0].value
        }
      })
    },
    /** 获取归类字段 */
    async getGlzd(data) {
      let _this = this
      await _this.$ajax.post("/api/xtglGlsz/getGlzd", data).then((res) => {
        if(res.data.code == '200') {
          _this.staffList = {}
          _this.staffList = (res.data.data.length > 0 ? res.data.data[0] : {});
        }
      })
    },
    /** 获取未归类数据 */
    async getWglList(data, flg) {
      let _this = this
      if(flg == 'query') {
        data.currentPage = 1;
        data.limit = _this.leftLimit;
        _this.leftCurrentPage = 1;
      } else {
        data.currentPage = _this.leftCurrentPage;
        data.limit = _this.leftLimit;
      }
      _this.leftQueryForm = {
        bfl: data.bfl,
        bmc: data.bmc,
        jdbh: data.jdbh,
        gldm: data.gldm,
        glmc: data.glmc,
        gllVal1: data.gllVal1,
        kjnd: data.kjnd,
        currentPage: data.currentPage,
        limit: data.limit,
      }
      await _this.$ajax.post("/api/xtglGlsz/getWglList", data).then((res) => {
        _this.wglListLoading = false;
        if(res.data.code == '200') {
          if(res.data.data.length > 0) {
            _this.leftTotal = res.data.data[0].TABLECOUNT;
          } else {
            _this.leftTotal = 0;
          }
          _this.transferData = []
          for(let tmp of res.data.data) {
            tmp.gll = tmp[_this.staffList.gldm] + '/' + tmp[_this.staffList.glmc]
            _this.transferData.push(tmp)
          }
        }
      }).catch((error) => {
        _this.wglListLoading = false;
      })
    },
    /** 获取已归类数据 */
    async getYglList(data, flg) {
      let _this = this
      if(flg == 'query') {
        data.currentPage = 1;
        data.limit = _this.leftLimit;
        _this.rightCurrentPage = 1;
      } else {
        data.currentPage = _this.rightCurrentPage;
        data.limit = _this.rightLimit;
      }
      _this.rightQueryForm = {
        bfl: data.bfl,
        bmc: data.bmc,
        jdbh: data.jdbh,
        gldm: data.gldm,
        glmc: data.glmc,
        gllVal2: data.gllVal2,
        currentPage: data.currentPage,
        limit: data.limit,
      }
      await _this.$ajax.post("/api/xtglGlsz/getYglList", data).then((res) => {
        if(res.data.code == '200') {
          if(res.data.data.length > 0) {
            _this.rightTotal = res.data.data[0].tableCount;
          } else {
            _this.rightTotal = 0;
          }
          _this.transferVal = []
          for(let tmp of res.data.data) {
            tmp.gll = tmp.gldm + '/' + tmp.glmc
            _this.transferVal.push(tmp)
          }
        }
      })
    },
    /** 更新归类设置 */
    updateGlsz() {
      let _this = this;
      for(let tmp of _this.leftStaffData) {
        tmp.bmc = _this.activeName,
        tmp.bfl = _this.bfl,
        tmp.jdbh = _this.jdbh,
        tmp.dm = tmp[_this.staffList.gldm]
        tmp.kjnd = tmp.KJND
      }
      _this.$ajax.post('/api/xtglGlsz/updateGlsz', _this.leftStaffData).then(async (res) => {
        if(res.data.code == '200') {
          _this.$message.success('归类更新成功');
          let tmpObj = {}
          tmpObj.bmc = _this.bmc
          tmpObj.bfl = _this.bfl
          tmpObj.jdbh = _this.jdbh
          tmpObj.gldm = _this.staffList.gldm
          tmpObj.glmc = _this.staffList.glmc
          tmpObj.kjnd = _this.kjnd
          tmpObj.gllVal1 = _this.gllVal1;
          tmpObj.gllVal2 = _this.gllVal2;
          await _this.getWglList(tmpObj);
          await _this.getYglList(tmpObj);
          _this.leftStaffData = []
          // 通过v-if手动销毁，重新渲染
          _this.stataFlg = false;
          _this.$nextTick(() => {
            _this.stataFlg = true;
          });
        }
      });
    },
    /** 撤销归类设置 */
    revokeGlsz() {
      let _this = this;
      for(let tmp of _this.rightStaffData) {
        tmp.bmc = _this.activeName,
        tmp.bfl = _this.bfl,
        tmp.jdbh = _this.jdbh,
        tmp.dm = tmp.gldm
      }
      _this.$ajax.post('/api/xtglGlsz/revokeGlsz', _this.rightStaffData).then(async (res) => {
        if(res.data.code == '200') {
          _this.$message.success('归类撤销成功');
          let tmpObj = {}
          tmpObj.bmc = _this.bmc
          tmpObj.bfl = _this.bfl
          tmpObj.jdbh = _this.jdbh
          tmpObj.gldm = _this.staffList.gldm
          tmpObj.glmc = _this.staffList.glmc
          tmpObj.kjnd = _this.kjnd
          await _this.getWglList(tmpObj);
          await _this.getYglList(tmpObj);
          _this.rightStaffData = []
          // 通过v-if手动销毁，重新渲染
          _this.stataFlg = false;
          _this.$nextTick(() => {
            _this.stataFlg = true;
          });
        }
      });
    },
    /** 获取已归类会计年度选项 */
    async getYglKjnd(treeId) {
      let _this = this
      _this.optionsYglKjnd = []
      await _this.$ajax.post("/api/xtglGlsz/getYglKjnd", _this.$qs.stringify({ treeId: treeId })).then((res) => {
        if(res.data.code == '200') {
          for(let tmpdata of res.data.data) {
            _this.optionsYglKjnd.push({
              label: tmpdata.kjnd,
              value: tmpdata.kjnd,
            })
          }
        }
      })
    },
    /** 获取未归类会计年度选项 */
    async getWglKjnd(data) {
      let _this = this
      _this.optionsWglKjnd = []
      await _this.$ajax.post("/api/xtglGlsz/getWglKjnd", _this.$qs.stringify({ bmc: data })).then((res) => {
        if(res.data.code == '200') {
          for(let tmpdata of res.data.data) {
            _this.optionsWglKjnd.push({
              label: tmpdata.kjnd,
              value: tmpdata.kjnd,
            })
          }
        }
      })
    },
    /** 复制会计年度 */
    copyKjnd() {
      let _this = this;
      let srcObj = { bmc: _this.activeName, bfl: _this.bfl, treeId: _this.treeId, kjnd: _this.srcKjnd }
      let obj = { srcGldmKjnd: srcObj, targetGldmKjnd: _this.targetKjnd }
      _this.$ajax.post('/api/xtglGlsz/copyKjnd', obj).then((res) => {
        _this.copyDiaFormVisible = false;
        if(res.data.code == '200') {
          _this.$message.success('复制成功');
        }
      }).catch((error) => {
        _this.copyDiaFormVisible = false;
      });
    },
    /** 获取所有页面 */
    getPages() {
      let _this = this
      _this.$ajax.post("/api/xtglGlsz/getPages").then((res) => {
        _this.listLoading = false;
        if(res.data.code == '200') {
          _this.optionsPages = []
          for(let tmpdata of res.data.data) {
            _this.optionsPages.push({
              label: tmpdata.pageName,
              value: tmpdata.pageId,
            })
          }
        } else {
          _this.listLoading = false;
        }
      })
    },
    // 将左边表格选择项存入staffData中
    handleStaffChange(rows, flg) {
      if(flg == 'left') {
        this.leftStaffData = [];
        if (rows) {
          rows.forEach(row => {
            if (row) {
              this.leftStaffData.push(row);
            }
          });
        }
      } else if(flg == 'right') {
        this.rightStaffData = [];
        if (rows) {
          rows.forEach(row => {
            if (row) {
              this.rightStaffData.push(row);
            }
          });
        }
      }
    },
    leftSelect(selection, row) {
      this.leftKjndStaffData = row
      if (selection.length > 1) {
        let del_row = selection.shift() 
        this.$refs.yglKjndLeftTable.toggleRowSelection(del_row, false) // 用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）
      }
    },
    rightSelect(selection, row) {
      this.rightKjndStaffData = []
      for(let tmp of selection) {
        this.rightKjndStaffData.push({ kjnd: tmp.kjnd })
      }
    },
    getRowKeys(row) {
      return Math.random();
    },
    handleClose(done) {
      this.$refs['ruleForm'].resetFields();
    },
    copyHandleClose(done) {
      this.srcKjnd = '';
      this.targetKjnd = []
      // this.leftKjndStaffData = []
      // this.rightKjndStaffData = []
      // this.$refs['copyRuleForm'].resetFields();
    },
    /** 页码改变时会触发 */
    leftHandleCurrentChange(uniqueNum, val) {
      this.leftCurrentPage = val;
      this.getWglList(this.leftQueryForm, 'currentChange');
    },
    /** 每页条数改变时触发 */
    leftHandleSizeChange(uniqueNum, val) {
      this.leftLimit = val;
      this.leftCurrentPage = 1;
      this.getWglList(this.leftQueryForm, 'sizeChange');
    },
    /** 页码改变时会触发 */
    rightHandleCurrentChange(uniqueNum, val) {
      this.rightCurrentPage = val;
      this.getYglList(this.rightQueryForm, 'currentChange');
    },
    /** 每页条数改变时触发 */
    rightHandleSizeChange(uniqueNum, val) {
      this.rightLimit = val;
      this.rightCurrentPage = 1;
      this.getYglList(this.rightQueryForm, 'sizeChange');
    },
  },
  created() {},
  mounted() {
    let _this = this
    _this.$requestUtil.getCodeInfoById(['NORMAL_CODE_TABLE_CATEGORY']).then(async tmpResult => {
      if(Object.keys(tmpResult).length > 0) {
        // 表分类
        let bflCodeList = tmpResult["NORMAL_CODE_TABLE_CATEGORY"];
        for(let tmp of bflCodeList) {
          _this.optionsBfl.push({
            label: tmp.name[_this.$i18n.locale],
            value: tmp.code,
          });
        }
      }
      // 表分类下所有表
      if(_this.optionsBfl.length > 0) {
        _this.bfl = _this.optionsBfl[0].value
        await _this.getOptionsTab(_this.bfl)
      }
      // 获取分类中的树
      await _this.getBflTree(_this.bfl, _this.activeName);
      await _this.getPages();
      await _this.getGlzd({ bmc: _this.activeName, bfl: _this.bfl });

      _this.$nextTick(() => {
        let aaa = $(".transferClass").width()
        if(aaa) {
          $(".el-transfer-panel").css({ "height": _this.screenHeight - 389 + 'px', "width": parseInt((aaa - 115)/2) + 'px', "min-width": '200px' });
          $(".el-transfer-panel__list.is-filterable").css("height", this.screenHeight - 466 + 'px');
        } else {
          $(".el-transfer-panel").css("height", _this.screenHeight - 389 + 'px');
          $(".el-transfer-panel").css("width", parseInt((_this.screenWidth - 200)/3.7) + 'px');
          $(".el-transfer-panel").css("min-width", '200px');
          $(".is-filterable").css("height", _this.screenHeight - 466 + 'px');
        }
      })
    });
    // 监听浏览器的宽和高
    _this.screenHeight = document.body.clientHeight
    _this.screenWidth = document.body.clientWidth
    window.addEventListener('resize', () => _this.screenHeight = window.innerHeight, false)
    window.addEventListener('resize', () => _this.screenWidth = window.innerWidth, false)
  },
}
</script>

<style lang="scss" scoped>
::v-deep .custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.el-divider {
  background-color: #409EFF;
}
::v-deep .el-divider--vertical {
  width: 5px;
  height: 1.5em;
  margin: 0 10px 0 0;
}
::v-deep .el-card__header {
  padding: 10px 20px;
}
::v-deep .isOkClass {
  .el-switch__label--left {
    position: relative;
    left: 40px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__core {
    width: 60px !important;
  }
  .el-switch__label--right {
    position: relative;
    right: 40px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }
  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}
.col2Class {
  padding: 0px 10px;
  .el-button {
    margin: 0px;
  }
}
::v-deep .selectClass {
  .el-input--mini .el-input__inner {
    height: 1.5em;
    line-height: 1.5em;
  }
  .el-input--mini .el-input__icon {
    line-height: 1.5em;
  }
}
::v-deep .copyBtnClass.el-button--mini {
  padding: 3px 15px;
}
::v-deep .leftKjndClass {
  .el-table__header-wrapper .el-checkbox {
    display: none;
  }
}
</style>